module.exports = __webpack_public_path__ + "static/media/rst2.90504995.svg";